import type { CSSProperties } from 'react';

export {
  typo,
  typeRole,
  typeClass,
  wfPageTitleStyle,
  wfTitleStyle,
  wfSectionTitleStyle,
  wfSubtitleStyle,
  wfLabelStyle,
  wfRowLabelStyle,
  wfHintStyle,
  wfBodyStyle,
  wfMutedStyle,
  wfHeroStyle,
  wfContinueStyle,
  wfGamesNameStyle,
  wfGamesSubStyle,
  wfGamesTabStyle,
  wfGamesDdiStyle,
  wfCardTitleStyle,
  wfCardSubStyle,
  wfActDateStyle,
  wfPillStyle,
  wfNavStyle,
  wfChipFontStyle,
  wfInpFontStyle,
  wfMdlLinkStyle,
  wfHdActionStyle,
  wfBrandStyle,
  wfGiLabelStyle,
  wfTickStyle,
} from '@/styles/typography';

/** Shared Cosmos / wireframe typography + form field tokens (Settings, Support, FAQ). */
export const wfSectionPad = {
  padding: 'calc(12px * var(--proto-scale))',
  gap: 'var(--wf-mdl-gap)',
} as const;

export const wfPageColumnStyle: CSSProperties = {
  maxWidth: 'var(--wf-mdl-game-w)',
  gap: 'var(--wf-mdl-gap)',
};

export const wfInputStyleBase: CSSProperties = {
  fontSize: 'var(--fs-input)',
  borderRadius: 'calc(7px * var(--proto-scale))',
  minHeight: 'calc(36px * var(--proto-scale))',
  paddingTop: 'var(--wf-inp-py)',
  paddingBottom: 'var(--wf-inp-py)',
  paddingRight: 'var(--wf-inp-px)',
  paddingLeft: 'var(--wf-inp-px)',
};

/** Shared form field surface — matches `.cosmos-form-control` in globals.css */
export const wfFormControlClass = 'cosmos-form-control';

/** Toolbar pill surface — Games filter row; matches form fill, pill shape */
export const wfToolbarControlClass = 'cosmos-filter-control';

export const wfSearchFormPad: CSSProperties = {
  padding: 'var(--wf-inp-py) var(--wf-inp-px)',
};

export const wfSearchToolbarPad: CSSProperties = {
  padding: 'var(--wf-chip-py) var(--wf-chip-px)',
};

export const wfFormFieldStackClass = 'flex flex-col min-w-0';

/** FAQ / Support filter row — equal columns, labels align top */
export const wfFilterGridClass =
  'grid grid-cols-1 sm:grid-cols-2 min-w-0 items-stretch';

export const wfFilterGridGapStyle: CSSProperties = {
  gap: 'calc(8px * var(--proto-scale))',
};

export const wfInputClass =
  `${wfFormControlClass} w-full font-ui text-ink placeholder:text-caption-muted focus:outline-none disabled:opacity-60 disabled:cursor-not-allowed`;

export const wfLabelClass =
  'block font-ui font-semibold text-caption-muted m-0 mb-[calc(4px*var(--proto-scale))]';

export const wfHintClass = 'font-ui text-caption-muted m-0';

export const wfSurfaceCardClass =
  'rounded-[8px] border border-border-ice bg-surface flex flex-col shrink-0';

/** Inset panel inside wireframe cards — Account OTP blocks, FAQ accordion rows */
export const wfInsetSurfaceClass =
  'rounded-[8px] border border-border-ice bg-[#0a1634] overflow-hidden';

export const wfAccordionTriggerClass =
  'w-full text-left font-ui font-semibold text-ink transition-colors flex items-center justify-between gap-4 hover:bg-white/10';

export const wfListStackStyle: CSSProperties = {
  gap: 'calc(6px * var(--proto-scale))',
};

export const wfAccordionPadStyle: CSSProperties = {
  padding: 'calc(10px * var(--proto-scale)) calc(12px * var(--proto-scale))',
};
